import { EducateNavHeader } from '@/components/brand/EducateNavHeader';
import { WelcomeScreen } from '@/pages/WelcomeScreen';
import { CompleteScreen } from '@/pages/CompleteScreen';
import { ErrorScreen, LoadingScreen } from '@/components/StatusScreens';
import { ModuleRenderer } from '@/pages/players/ModuleRenderer';
import { useEducateModule } from '@/hooks/useEducateModule';
import { EDUCATE_TYPE_LABEL } from '@/utils/units';

export default function App() {
  const module = useEducateModule();
  const { phase, error, storyline, progress, units, start, restart } = module;

  if (phase === 'loading') return <Shell>{<LoadingScreen />}</Shell>;

  if (phase === 'error' || !storyline) {
    return (
      <Shell>
        <ErrorScreen message={error ?? 'This module is unavailable.'} />
      </Shell>
    );
  }

  if (phase === 'module') return <ModuleRenderer module={module} />;

  return (
    <Shell title={storyline.uiContent.title} subtitle={EDUCATE_TYPE_LABEL[storyline.educateType]}>
      {phase === 'welcome' && (
        <WelcomeScreen
          storyline={storyline}
          progress={progress}
          unitCount={units.length}
          onStart={start}
        />
      )}

      {phase === 'complete' && <CompleteScreen storyline={storyline} onRestart={restart} />}
    </Shell>
  );
}

function Shell({
  title = '4E Educate',
  subtitle = 'Educate',
  children
}: {
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
}) {
  return (
    <EducateNavHeader eyebrow={subtitle} title={title}>
      <main className="w-full px-[18%] py-12">{children}</main>
    </EducateNavHeader>
  );
}
